import { LayoutsStartersRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/layouts/starters')({
  component: LayoutsStartersRoute,
});
